import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useDatos from "./useDatos";
import "./style.css";
import {
  FaExpand,
  FaRulerCombined,
  FaBorderAll,
  FaCubes,
  FaWhatsapp,
} from "react-icons/fa";
import Carrusel from "../../components/Carrusel/Carrusel";
import API from "../../hooks/Fetchs";
import { FaFacebookF, FaTwitter } from "react-icons/fa";

const MostrarID = () => {
  const { id, slug } = useParams();
  const navigate = useNavigate();
  const urlBase = API.read;
  const url = id ? `${urlBase}?id=${id}` : urlBase;
  const { datos: inmuebles, loading, error } = useDatos(url);

  // Aseguramos que 'inmuebles' sea un array (en caso de que sea un objeto)
  const inmueble = Array.isArray(inmuebles) ? inmuebles[0] : inmuebles;

  useEffect(() => {
    document.title = id ? `Percara Negocios Inmobiliarios` : "Lista de Propiedades";

    // Validamos que el slug de la URL coincida con el slug del inmueble
    if (inmueble && slug !== inmueble.slug) {
      // Si el slug no coincide, redirigimos o mostramos un mensaje
      navigate(`/inmueble/${inmueble.id}/${inmueble.slug}`, { replace: true });
    }
  }, [id, slug, inmueble, navigate]);

  if (loading) return <p className="loading">Cargando datos...</p>;
  if (error) return <p className="error">Error al cargar los datos: {error.message}</p>;
  if (!inmueble) return <p>No hay información disponible para este inmueble.</p>;

  const baseUrl = `${API.readimg}/${inmueble.id}`;
  const shareUrl = `https://inmobiliariapercara.com/#/inmueble/${inmueble.id}/${inmueble.slug}`;
  const shareText = inmueble ? `Mira esta propiedad: ${inmueble.direccion}, ${inmueble.lugar}` : "Propiedad no encontrada";

  const imagenes = [
    ...[1, 2, 3]
      .map((num) => inmueble[`img_portada_${num}`])
      .filter((img) => img && img.length >= 5),
    ...[1, 2, 3, 4, 5, 6, 7]
      .map((num) => inmueble[`img${num}`])
      .filter((img) => img && img.length >= 7),
  ].map((img) => `${baseUrl}/${img}`);


  // Función para abrir Google Maps
  const abrirGoogleMaps = () => {
    const { latitud, longitud, ubicacion } = inmueble;

    if (latitud && longitud) {
      // Si hay latitud y longitud, abrimos el mapa directamente en esas coordenadas
      window.open(`https://www.google.com/maps?q=${latitud},${longitud}`, "_blank");
    } else if (ubicacion && ubicacion.trim() !== "") {
      // Si no hay coordenadas, pero sí dirección, usamos la dirección
      const query = encodeURIComponent(ubicacion);
      window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, "_blank");
    } else {
      alert("Ubicación no disponible para este inmueble.");
    }
  };

  return (
    <main className="container contenedor-card-id">
      {/* Botón de Volver */}
      <button className="btn-back" onClick={() => navigate(-1)}>
        Volver
      </button>
      <article className="contenedor-card-i">
        <div className="card shadow-sm">
          {/* Carrusel o Imagen Principal */}
          {imagenes.length > 0 ? (
            <Carrusel images={imagenes} className="carrusel-id no-indicators juanma" />
          ) : (
            <img
              src={`${API.readimg}/default.jpg`}
              alt="Imagen no disponible"
              className="centered-img"
              loading="lazy"
            />
          )}
          {/* Contenido de la Tarjeta */}
          <div className="card-body">
            <h2 className="card-title">
              {inmueble.direccion} - {inmueble.lugar}
            </h2>

            {/* Descripción */}
            <div className="contenedor-textos">
              <p style={{ fontStyle: "italic", color: "#555", whiteSpace: 'pre-line' }}>{inmueble.descripcion}</p>
            </div>

            {/* Datos Numéricos */}
            <div className="info-container">
              <div className="contenedor-numeros">
                {inmueble.cantidad_hectareas > 0 && (
                  <p>
                    <FaCubes style={{ color: "#6EB41E" }} />
                    <strong>Hectáreas:</strong> {inmueble.cantidad_hectareas}
                  </p>
                )}

                {inmueble.superficie_terreno > 0 && (
                  <p>
                    <FaBorderAll style={{ color: "#007BFF" }} />
                    <strong>Superficie del terreno:</strong> {inmueble.superficie_terreno} m²
                  </p>
                )}

                {inmueble.medida_frente > 0 && (
                  <p>
                    <FaRulerCombined style={{ color: "#FF5733" }} />
                    <strong>Frente:</strong> {inmueble.medida_frente} m
                  </p>
                )}

                {inmueble.medida_fondo > 0 && (
                  <p>
                    <FaRulerCombined style={{ color: "#FF5733" }} />
                    <strong>Fondo:</strong> {inmueble.medida_fondo} m
                  </p>
                )}

                {inmueble.superficie_cubierta > 0 && (
                  <p>
                    <FaExpand style={{ color: "#C70039" }} />
                    <strong>Sup cubierta:</strong> {inmueble.superficie_cubierta} m²
                  </p>
                )}

                {inmueble.superficie_semicubierta > 0 && (
                  <p>
                    <FaExpand style={{ color: "#C70039" }} />
                    <strong>Sup semicubierta:</strong> {inmueble.superficie_semicubierta} m²
                  </p>
                )}

                <div className="container-botones-mostrar">
                  {/* Mostrar ubicación */}
                  {(inmueble.ubicacion || (inmueble.latitud && inmueble.longitud)) && (
                    <div className="googlemaps-container">
                      <p>
                        <button
                          className="btn-google-maps"
                          onClick={abrirGoogleMaps}
                        >
                          Ver en Google Maps
                        </button>
                      </p>
                    </div>
                  )}

                  {/* Botón de WhatsApp */}
                  <div className="whatsapp-container">
                    <a
                      href={`https://wa.me/+5493456553422?text=Hola,%20vi%20esta%20propiedad%20en%20tu%20página:%20${encodeURIComponent(
                        inmueble.direccion
                      )}%20${encodeURIComponent(inmueble.lugar)}.%20Sigue%20disponible?`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-whatsapp"
                    >
                      <FaWhatsapp style={{ marginRight: "0.5rem", fontSize: "1.2rem" }} />
                      Preguntar por esta propiedad
                    </a>
                  </div>

                  {/* Compartir propiedad */}
                  <div className="share-buttons w-100">
                    <span className="share-title">Compartir:</span>

                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-share facebook"
                      title="Compartir en Facebook"
                    >
                      <FaFacebookF />
                    </a>

                    <a
                      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-share twitter"
                      title="Compartir en Twitter"
                    >
                      <FaTwitter />
                    </a>

                    <a
                      href={`https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-share whatsapp"
                      title="Compartir en WhatsApp"
                    >
                      <FaWhatsapp />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
};

export default MostrarID;
